// extracted by mini-css-extract-plugin
export var mt0 = "widget-get-started-module--mt-0--2888d";
export var mt1 = "widget-get-started-module--mt-1--d3fa0";
export var mt2 = "widget-get-started-module--mt-2--70347";
export var mt3 = "widget-get-started-module--mt-3--5fa95";
export var mt4 = "widget-get-started-module--mt-4--4babc";
export var mt5 = "widget-get-started-module--mt-5--477b0";
export var mt6 = "widget-get-started-module--mt-6--6289f";
export var widgetGetStarted = "widget-get-started-module--widget-get-started--91158";
export var widgetGetStarted__copy = "widget-get-started-module--widget-get-started__copy--5367e";
export var widgetGetStarted__ctas = "widget-get-started-module--widget-get-started__ctas--ebcc7";
export var widgetGetStarted__ctas__cta = "widget-get-started-module--widget-get-started__ctas__cta--ffa66";
export var widgetGetStarted__headline = "widget-get-started-module--widget-get-started__headline--5121a";
export var widgetGetStarted__iconBg = "widget-get-started-module--widget-get-started__icon-bg--c413e";